import React, { useEffect, useState } from "react";
import styles from './index.module.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMedal, faSearch } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams } from "react-router-dom";
import { verifyCertificate } from "../redux/features/certificate/certificateService";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import CertificateImage from "../components/Certificate/CertificateImage";
import IBSLogo from "../assets/images/brand/Uni_logo_landscape.png";
import CDCCertificateImage from "../components/Certificate/CDCCertificate/CDCOther/CDCCertificateImage";
import IBSCOfficialCertificateImage from "../components/Certificate/IBSCCertificate/IBSCOfficial/IBSCOfficialCertificateImage";
import IBSUOfficialCertificateImage from "../components/Certificate/IBSUCertificate/IBSUOfficial/IBSUOfficialCertificateImage";

const VerificationLayout = () => {
    const { document_ref } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isLoadingVerification, isCertificateVerified, verifiedCertificate } = useSelector((state) => state.certificate.verifyCertificate);

    const [regNumber, setRegNumber] = useState(null);
    const [certificateImage, setCertificateImage] = useState(null);

    useEffect(() => {
        dispatch(verifyCertificate({ document_ref }));
    }, [document_ref, dispatch]);

    useEffect(() => {
        if (verifiedCertificate) {
            setCertificateImage(null);
        }
    }, [verifiedCertificate]);

    const handleSearch = (e) => {
        e.preventDefault();
        if (regNumber) {
            navigate(`/document_ref/${regNumber}`);
        }
    };

    const [location, setLocation] = useState(null);

    useEffect(() => {
        fetch("https://ibs.ardillalabs.com/api/v1/api/location")
            .then(res => res.json())
            .then(data => setLocation(data));
    }, [])

    return (
        <div className={styles.container}>
            <div className={styles.searchCard}>
                <div className={styles.studentSearchSection}>
                    <input
                        id="regNumber"
                        placeholder="Document Reference Id"
                        type="text"
                        value={regNumber || ''}
                        name="regNumber"
                        onChange={(e) => setRegNumber(e.target.value)}
                        className={styles.searchInput}
                    />
                    <button
                        type="button"
                        className={styles.searchBtn}
                        onClick={handleSearch}
                    >
                        <FontAwesomeIcon icon={faSearch} aria-hidden="true" color="white" />
                    </button>
                </div>
            </div>
            {isLoadingVerification ?
                <div className={styles.verificationCard}>
                    <Skeleton height={50} width={50} customHighlightBackground="linear-gradient(90deg, var(--base-color) 40%, var(--highlight-color) 80%, var(--base-color) 60%)" />
                    <Skeleton height={30} className={styles.titleSk} customHighlightBackground="linear-gradient(90deg, var(--base-color) 40%, var(--highlight-color) 80%, var(--base-color) 60%)" />
                    <Skeleton height={2} className={styles.titleLineSk} customHighlightBackground="linear-gradient(90deg, var(--base-color) 40%, var(--highlight-color) 80%, var(--base-color) 60%)" />
                    <Skeleton height={20} count={3} className={styles.paraSk} customHighlightBackground="linear-gradient(90deg, var(--base-color) 40%, var(--highlight-color) 80%, var(--base-color) 60%)" />
                    <div className={styles.row}>
                        <Skeleton height={20} width={200} customHighlightBackground="linear-gradient(90deg, var(--base-color) 40%, var(--highlight-color) 80%, var(--base-color) 60%)" />
                        <Skeleton height={20} width={200} customHighlightBackground="linear-gradient(90deg, var(--base-color) 40%, var(--highlight-color) 80%, var(--base-color) 60%)" />
                    </div>
                    <Skeleton height={20} width={200} customHighlightBackground="linear-gradient(90deg, var(--base-color) 40%, var(--highlight-color) 80%, var(--base-color) 60%)" />
                </div> :
                isCertificateVerified ?
                    verifiedCertificate?.document_ref !== verifiedCertificate?.certificate?.document_ref ?
                        <div className={styles.verificationCard}>
                            <FontAwesomeIcon icon={faMedal} size="4x" color="green" />
                            <h1 className={styles.certificateTitle}>This certificate is Re-Issued</h1>
                            <p className={styles.detailsPara}><span className={styles.highlightText}>This certificate </span> (<span className={styles.highlightText}>{verifiedCertificate?.document_ref}</span>) has has been replaced by Certificate No: <span className={styles.highlightText}>{verifiedCertificate?.certificate?.document_ref}</span>.</p>
                            {/* <div className={styles.row}>
                            <div className={styles.dateText}>Issue date: {verifiedCertificate?.certificate_date}</div>
                            <div className={styles.dateText}>Completion date: {verifiedCertificate?.completion_date}</div>
                        </div> */}
                            <img src={IBSLogo} alt="Logo" className={styles.verifyLogoImg} />
                        </div>
                        :
                        verifiedCertificate?.certificate_status === 'Cancelled' ?
                            <div className={styles.verificationCard}>
                                <FontAwesomeIcon icon={faMedal} size="4x" color="red" />
                                <h1 className={styles.certificateTitle}>This Certificate is Cancelled</h1>
                                <p className={styles.detailsPara}><span className={styles.highlightText}>{verifiedCertificate?.document_ref}</span> certificate has been cancelled. Reason {verifiedCertificate?.reason}.</p>
                                <img src={IBSLogo} alt="Logo" className={styles.verifyLogoImg} />
                            </div>
                            :
                            <div className={styles.verificationCard}>
                                <FontAwesomeIcon icon={faMedal} size="4x" color="green" />
                                <h1 className={styles.certificateTitle}>This is a Valid Certificate</h1>
                                <p className={styles.detailsPara}><span className={styles.highlightText}>{verifiedCertificate?.certificate?.student_name}</span> (<span className={styles.highlightText}>{verifiedCertificate?.document_ref}</span>) has successfully completed <span className={styles.highlightText}>{verifiedCertificate?.certificate?.course_batch?.course?.name}</span> on {verifiedCertificate?.certificate?.completion_date} from IBSUniversity.</p>
                                <div className={styles.row}>
                                    <div className={styles.dateText}>Issue date: {verifiedCertificate?.certificate?.issued_date}</div>
                                    <div className={styles.dateText}>Completion date: {verifiedCertificate?.certificate?.completion_date}</div>
                                </div>
                                <img src={IBSLogo} alt="Logo" className={styles.verifyLogoImg} />
                            </div>
                    :
                    <div className={styles.verificationCard}>
                        <FontAwesomeIcon icon={faMedal} size="4x" color="red" />
                        <h1 className={styles.certificateTitle}>This is not a Valid Certificate</h1>
                        <p>The certificate for this document reference ID was not found.</p>
                    </div>
            }
            {isCertificateVerified && verifiedCertificate && (
                (verifiedCertificate?.certificate?.certificate_template?.name === 'IBSU Offical Certificate' && verifiedCertificate?.certificate?.certificate_template?.certificate_type?.name === 'OFFICIAL' ?
                    <IBSUOfficialCertificateImage data={verifiedCertificate?.certificate} onImageGenerated={setCertificateImage} />
                    :
                    verifiedCertificate?.certificate?.certificate_template?.name === 'IBSC Official Certificate' && verifiedCertificate?.certificate?.certificate_template?.certificate_type?.name === 'OFFICIAL' ?
                        <IBSCOfficialCertificateImage data={verifiedCertificate?.certificate} onImageGenerated={setCertificateImage} />
                        :
                        <CDCCertificateImage data={verifiedCertificate?.certificate} onImageGenerated={setCertificateImage} />
                )
            )}

            {/* Display Generated Image Below */}
            {((certificateImage && verifiedCertificate?.document_ref === verifiedCertificate?.certificate?.document_ref) && (certificateImage && verifiedCertificate?.certificate_status !== 'Cancelled')) && (
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <p>Certificate Preview</p>
                    <img
                        src={certificateImage}
                        alt="Certificate Preview"
                        style={{ width: "100%", maxWidth: "400px", border: "1px solid #ccc" }}
                    />
                </div>
            )}
        </div>
    );
};

export default VerificationLayout;
